<form [formGroup]="mapForm" (ngSubmit)="onSubmit()" class="pd-30 scroll" fxLayout="column" fxLayoutGap="30px">

    <mat-form-field appearance="outline">
        <mat-label>{{ "COUNTRY" | translate }}</mat-label>
        <mat-select formControlName="country">
            <mat-option *ngFor="let country of countries | async" [value]="country">{{ country }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>{{ "CITY" | translate }}</mat-label>
        <mat-select formControlName="city">
            <mat-option *ngFor="let city of cities | async" [value]="city">{{ city }}</mat-option>
        </mat-select>
    </mat-form-field>

    <agm-map [zoom]="zoom" [latitude]="cameraLat" [longitude]="cameraLng" style="height: 300px;">

        <agm-marker [label]="{color:'white',text:item.name}" *ngFor="let item of pickupPoints | async" [latitude]="item?.lat" [longitude]="item?.lon"></agm-marker>

    </agm-map>

    <mat-radio-group formControlName="address" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
        <mat-radio-button *ngFor="let item of pickupPoints | async" [value]="item" (change)="onPickPoint($event)">
            {{item.name}}
        </mat-radio-button>

    </mat-radio-group>

   <!--  <div fxFlex></div> -->

    <button mat-flat-button color="primary" class="my-button">{{"CONTINUE" |
        translate}}</button>
</form>
